﻿/* JavaScript files */
import "jzip";
import "jquery";

import "@progress/kendo-ui/js/kendo.all.min.js";
import "@progress/kendo-ui/js/kendo.aspnetmvc.min.js";
import "@progress/kendo-ui/js/cultures/kendo.culture.nl-NL.min.js";
import "@progress/kendo-ui/js/messages/kendo.messages.nl-NL.min.js";

import "./kendotweaks.js";
import "./dateConverter.js";
import "./DateFunctions.js";
import "./general-functions.js";
